import { createContext, useContext, useEffect, useState } from "react";

const BandwidthContext = createContext(undefined);

const STORAGE_KEY = "ao-bandwidth";

function getInitial() {
  if (typeof window === "undefined") return false;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === "low") return true;
  if (stored === "normal") return false;
  // Auto-enable when the browser/OS signals a metered or data-saving connection.
  const saveData =
    typeof navigator !== "undefined" &&
    navigator.connection &&
    navigator.connection.saveData;
  const reducedData = window.matchMedia("(prefers-reduced-data: reduce)").matches;
  return Boolean(saveData || reducedData);
}

export function BandwidthProvider({ children }) {
  const [lowData, setLowData] = useState(getInitial);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-bandwidth",
      lowData ? "low" : "normal"
    );
    window.localStorage.setItem(STORAGE_KEY, lowData ? "low" : "normal");
  }, [lowData]);

  const toggleBandwidth = () => setLowData((v) => !v);

  return (
    <BandwidthContext.Provider value={{ lowData, toggleBandwidth }}>
      {children}
    </BandwidthContext.Provider>
  );
}

export function useBandwidth() {
  const ctx = useContext(BandwidthContext);
  if (!ctx) throw new Error("useBandwidth must be used within a BandwidthProvider");
  return ctx;
}
